import { render, staticRenderFns } from "./SurfacePostComment.vue?vue&type=template&id=5361b04a&scoped=true&"
import script from "./SurfacePostComment.vue?vue&type=script&lang=ts&"
export * from "./SurfacePostComment.vue?vue&type=script&lang=ts&"
import style0 from "./SurfacePostComment.vue?vue&type=style&index=0&id=5361b04a&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5361b04a",
  null
  
)

export default component.exports